import { render, staticRenderFns } from "./employeeTrainings.vue?vue&type=template&id=cb23783e&scoped=true"
import script from "./employeeTrainings.vue?vue&type=script&lang=js"
export * from "./employeeTrainings.vue?vue&type=script&lang=js"
import style0 from "./employeeTrainings.vue?vue&type=style&index=0&id=cb23783e&prod&scoped=true&lang=css"
import style1 from "./employeeTrainings.vue?vue&type=style&index=1&id=cb23783e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb23783e",
  null
  
)

export default component.exports